import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

import { getConfig } from '@/app/config'
import { keys } from '@/app/i18n'
import { notFoundLocation } from '@/app/router/not-found'

/**
 * AI mode (docs/ai-mode/GOALS.md): the chat + canvas page and the view gallery (every block of the view spec, for the
 * renderer's review and tests). Both behind the beta flag — checked when the route is entered, because route files
 * are evaluated before `loadConfig()` runs. `layout: 'ai'`: the navbar without the vertical nav (src/app/layouts).
 */
const betaOnly = (to: RouteLocationNormalized) => (getConfig().betaFeature ? true : notFoundLocation(to))

const routes: RouteRecordRaw[] = [
  {
    path: '/ai',
    name: 'ai-mode',
    component: () => import('./views/AiModeView.vue'),
    beforeEnter: betaOnly,
    meta: { resource: 'always', layout: 'ai', pageTitle: keys.t('aiMode.route.title.aiMode') },
  },
  {
    path: '/ai/gallery',
    name: 'ai-mode-gallery',
    component: () => import('./views/AiGalleryView.vue'),
    beforeEnter: betaOnly,
    meta: { resource: 'always', layout: 'ai', pageTitle: keys.t('aiMode.route.title.gallery') },
  },
]

export default routes
